// export default App;
import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

//Para los PDA/Desktop
import Navbar from "./components/navbar/Navbar";
import Logout from "./pages/Logout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
//Desktop
import Inventario from "./pages/bodega/Desktop/Inventario";
//import Despachos from "./pages/bodega/Desktop/Despachos";
//Tablet
import EntregasTab from "./pages/bodega/Tablet/Entregas";
//
import Bitacoras from "./pages/flotamaq/Bitacoras";

//PDA
import InventarioPDA from "./pages/bodega/Pda/Inventario";
import PreparacionPDA from "./pages/bodega/Pda/Preparacion";
import DespachosPDA from "./pages/bodega/Pda/Despachos";
import ProductoPDA from "./pages/bodega/Pda/Producto";
import DespachoscorreoPDA from "./pages/bodega/Pda/DespachosCorreo";
//Servicios
import authService from "./services/maestros.service";
//Redux
import { setUser } from "./store/userSlice";
import { useDispatch, useSelector } from "react-redux";

const App = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  const dispatch = useDispatch();

  const [UserStateDatos, setUserStateDatos] = useState(false);
  const userState = useSelector((state) => state.user);

  useEffect(() => {
    setUserStateDatos(userState !== null);
  }, [userState]);

  useEffect(() => {
    try {
      const userlocal = JSON.parse(localStorage.getItem("user_gandara"));
      if (userlocal) {
        authService.verificar().then(async (data) => {
          if (data.status === 200) {
            //si no tiene datos el redux, extraer datos de la base de datos.
            if (UserStateDatos === false) {
              const result = await authService.logid(data.data.Id);
              if (result.status === 200) {
                const datos = result.data;
                dispatch(setUser(datos));
                setLoggedIn(true);
              }
            }
          } else {
            setLoggedIn(false);
          }
        });
      } else {
        setLoggedIn(false);
      }
    } catch (error) {
      setLoggedIn(false);
    }
  }, [UserStateDatos, dispatch]);

  const verifyAuthentication = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user_gandara"));
      if (user) {
        authService.verificar().then((data) => {
          if (data.status === 200) {
            setLoggedIn(true);
          } else {
            setLoggedIn(false);
          }
        });
      } else {
        setLoggedIn(false);
      }
    } catch (error) {
      setLoggedIn(false);
    }
  };
  const handleLogin = () => {
    verifyAuthentication();
  };

  const handleLogout = () => {
    setLoggedIn(false);
  };

  return (
    <>
      <Navbar loggedIn={loggedIn} />
      <Routes>
        <Route
          path="/"
          element={loggedIn ? <Dashboard /> : <Login onLogin={handleLogin} />}
        />
        <Route
          path="/dashboard"
          element={loggedIn ? <Dashboard /> : <Navigate to="/" replace />}
        />
        <Route
          path="/inventario"
          element={loggedIn ? <Inventario /> : <Navigate to="/" replace />}
        />
        <Route
          path="/productopda"
          element={loggedIn ? <ProductoPDA /> : <Navigate to="/" replace />}
        />
        <Route
          path="/inventariopda"
          element={loggedIn ? <InventarioPDA /> : <Navigate to="/" replace />}
        />
        <Route
          path="/preparacionpda"
          element={loggedIn ? <PreparacionPDA /> : <Navigate to="/" replace />}
        />
        <Route
          path="/despachospda"
          element={loggedIn ? <DespachosPDA /> : <Navigate to="/" replace />}
        />
        <Route
          path="/despachoscorreopda"
          element={
            loggedIn ? <DespachoscorreoPDA /> : <Navigate to="/" replace />
          }
        />
        <Route
          path="/entregas"
          element={loggedIn ? <EntregasTab /> : <Navigate to="/" replace />}
        />
        <Route
          path="/bitacoras"
          element={loggedIn ? <Bitacoras /> : <Navigate to="/" replace />}
        />
        <Route
          path="/logout"
          element={
            loggedIn ? (
              <Logout onLogout={handleLogout} />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
      </Routes>
    </>
  );
};

export default App;
